import { render, staticRenderFns } from "./Hangman.vue?vue&type=template&id=ba5fda6c&scoped=true&"
import script from "./Hangman.vue?vue&type=script&lang=js&"
export * from "./Hangman.vue?vue&type=script&lang=js&"
import style0 from "./Hangman.vue?vue&type=style&index=0&id=ba5fda6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5fda6c",
  null
  
)

export default component.exports